import { render } from "./index.vue?vue&type=template&id=c265d522&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=c265d522&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=c265d522&lang=css"
import "./index.vue?vue&type=style&index=2&id=c265d522&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c265d522"]])

export default __exports__